/**
 * Truncate string to a certain length
 */
export const truncateString = (
    str: string,
    length: number,
    postFix: string = '..'
) => (str.length > length ? str.substring(0, length).trim() + postFix : str);
